// wrapper for all functionalities

/**
 * Primary class for the functionalities and primary module container
 * @class ABDOMap
 * @property {string} version 
 * @property {string} revision
 */
function ABDOMap() {
    this.version = "1.3";
    this.revision = "e6b43ff0eb7a8bf54998bf56ce1ec2465b09e74c";

    this._init();
}

(function($){ 
    $.prototype = {
        _init: function() {
            this._enable_debug_alert();
            ABDOUtil.update_map_links();
        }, 

        _onerror: function(msg, url, linenumber) {
            if (event.defaultPrevented)
            alert('Error message: ' + msg + '\nURL: ' + url + '\nLine Number: ' + linenumber);
            return false;
        },

        _enable_debug_alert: function() {
            if (this._is_dev()) {
                // disabled temporarily due to a chrome error:  https://stackoverflow.com/questions/72396527/evalerror-possible-side-effect-in-debug-evaluate-in-google-chrome
                // window.onerror = this._onerror.bind(this);
            }
        },

        _get_pagename: function() {
            return document.URL.split('/').pop();
        },

        _is_dev: function() {
            return this._get_pagename()[0] == '_';
        }, 
    };

    if (typeof(window) !== "undefined") {
        $.instance = new $();
    }

    /**
     * Creates basic inheritance of functions
     * @param {Function} child_func 
     * @param {Function} parent_func 
     */
     $._inherit = function(child_func, parent_func) {
        child_func.prototype = Object.create(parent_func.prototype);
        child_func.prototype.constructor = parent_func;
        Object.defineProperty(child_func.prototype, 'constructor', {
            value: parent_func,
            enumerable: false,
            writable: true
        });
    };

    $._create_component = function(component_func, members) {
        $._inherit(component_func, $.Component);
        Object.assign(component_func.prototype, members);
    };

    $._get_default_zoom = function() {
        var viewport = ABDOUtil.getViewer().viewport;
        var max_zoom = viewport.getMaxZoom();
        var min_zoom = viewport.getMinZoom();
        
        return (max_zoom - min_zoom) / 10.0;
    };

    // イベントの機能を付与 
    Emitter($);

})(ABDOMap);